module.exports = __webpack_public_path__ + "static/media/SM-ST-3.30a7ec5c.mp3";